import { render, staticRenderFns } from "./lossAnalysis.vue?vue&type=template&id=06a3e697&scoped=true&"
import script from "./lossAnalysis.vue?vue&type=script&lang=js&"
export * from "./lossAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./lossAnalysis.vue?vue&type=style&index=0&lang=css&"
import style1 from "./lossAnalysis.vue?vue&type=style&index=1&id=06a3e697&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a3e697",
  null
  
)

export default component.exports